import type { PartnerFormConfig } from '@portal/ui-library/dist/models';
import { useConfigContext } from 'contexts/ConfigContext';
import { useHealthInsuranceContext } from 'contexts/HealthInsuranceContext';

export const partnerFormConfig: PartnerFormConfig = {
  useConfigContext,
  useInsuranceContext: useHealthInsuranceContext as PartnerFormConfig['useInsuranceContext']
};
